import { render } from "./ConfigServerData.vue?vue&type=template&id=431459d8&scoped=true"
import script from "./ConfigServerData.vue?vue&type=script&lang=js"
export * from "./ConfigServerData.vue?vue&type=script&lang=js"

import "./ConfigServerData.vue?vue&type=style&index=0&id=431459d8&scoped=true&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-431459d8"]])

export default __exports__